import { useMediaQuery } from '@ui/hooks/useMediaQuery';

export const useIsMobile = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  return isMobile;
};
